<template>
    <div class="home-form">
        <van-nav-bar class="nav-bar" title="个人用户" left-text="返回" left-arrow @click-left="$router.push({path:'/mobileRegister'})" />
        <el-form ref="person" :model="formData"  :rules="rules" label-width="100px">
            <el-form-item label="账户名称" prop="accountName">
                <el-input v-model="formData.accountName" class="handle-input" placeholder="请输入账户名称"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="contactPhone">
                <el-input v-model="formData.contactPhone" class="handle-input" placeholder="请输入联系电话"></el-input>
            </el-form-item>
            <el-form-item label="用户名" prop="userName">
                <el-input v-model="formData.userName" class="handle-input" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
                <el-input v-model="formData.email" class="handle-input" placeholder="请输入电子邮箱"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="passWord">
                <el-input v-model="formData.passWord" class="handle-input" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassWord">
                <el-input v-model="formData.confirmPassWord" class="handle-input" placeholder="请输入确认密码"></el-input>
            </el-form-item>
            <el-form-item label="渠道推荐码">
                <el-input v-model="formData.channelCode" class="handle-input" placeholder="请输入渠道推荐码"></el-input>
            </el-form-item>
        </el-form>
        <el-button @click="getRegisterUser">提 交</el-button>
    </div>
</template>

<script>
import {
    registerDemandPerson
} from '@/api/index';
import { Toast } from 'vant';

export default {
    
    data() {
        var validatePass = (rule, value, callback) => {
			if(value === "" || value === null){
                callback(new Error("请输入确认密码"));
            }else if(this.formData.passWord !== value){
                callback(new Error("两次输入密码不一致"));
            }else {
                callback();
            }
		};
        return {
            formData:{
                accountName:'',//账户名称
                contactPhone:'',//联系电话
                userName:'',//用户名
                email:'',//电子邮箱
                passWord:'',//密码
                confirmPassWord:'',//确认密码
                channelCode:'', //渠道推荐码
            },
            rules:{
                accountName: [
                    { required: true, message: '请输入账户名称', trigger: 'blur' }
                ],
                contactPhone: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' },
                    //联系电话正则验证
                    {
                        pattern: /^1[3456789]\d{9}$/,
                        message: '请输入正确的联系电话',
                        trigger: 'blur'
                    }
                ],
                userName: [
                    { required: true, message: '请输入用户名', trigger: 'blur' }
                ],
                email: [
                    { required: true, message: '请输入电子邮箱', trigger: 'blur' },
                    //电子邮箱正则验证
                    {
                        pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
                        message: '请输入正确的电子邮箱',
                        trigger: 'blur'
                    }
                ],
                passWord: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                ],
                confirmPassWord: [
                    { required: true, message: '请输入确认密码', trigger: 'blur' },
                    //确认密码 与 密码 保持一致
                    {
                        validator: validatePass,
                        trigger: 'blur'
                    }
                ],
            }
            
        } 
    },
    methods:{
        getRegisterUser(){
            this.$refs['person'].validate(valid => {
                if (valid) {
                    this.registerUser();//表单必填验证通过  提交表单
                } else {
                    return false;
                }
            });
        },
        registerUser(){
            let paramObj = {
                account:this.formData.userName,//账号
                password:this.formData.passWord,//密码
                userName:this.formData.accountName,//用户名
                phone:this.formData.contactPhone,//联系电话
                email:this.formData.email,//电子邮箱
                channelStr:this.formData.channelCode,//渠道推荐码
            }
            registerDemandPerson(paramObj).then(res=>{
                if(res.data){
                    Toast.success('注册成功,欢迎登录')
                    this.$refs.person.resetFields();//清空表单验证
                    this.$router.push('/')
                }else {
                    Toast.error('注册失败');

                }
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.el-form{
    margin-top:10px;
    padding:0 10px;
}
.home-form{
    width:100%;
    height:auto;
    margin:0 auto;
    // padding:0 10px;
    .handle-input{
        // width:200px;
    }
    button{
        width:150px;
        height:40px;
        border:0;
        outline:none;
        color:#fff;
        margin:0 auto;
        border-radius:5px;
        background-color:#0066ff;
        cursor:pointer;
        margin-left:35%;
    }
}
</style>
<style scoped>
::v-deep .el-form-item__label{
    line-height:20px !important;
}
/* ::v-deep .el-form-item{
    margin-bottom:10px !important;
} */
::v-deep .el-upload-dragger{
    width:570px;
    height:120px;
}
::v-deep .el-upload-dragger .el-icon-upload {
    margin:15px 0;
}
</style>
